module.exports = "https://files.cnvos.si/static/images/zdravje.png?91cb52a38b42d3add3027f690d14cacb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/zdravje.png
// module id = 127
// module chunks = 1 2